import { restoreSupervisorioTourDemo } from '../../../containers/Supervisorio'

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))

const EDIT_MODAL_CONTENT = '.modal.show [data-tour="supervisorio-modal-edit"] .modal-content'
const WIDGET_MODAL_OPEN = '.modal.show [data-tour="supervisorio-widget-descricao"]'
const TIPO_COMPONENTE_DESCRIPTION = [
    'Cada tipo de componente apresenta os dados de uma forma diferente. As opções disponíveis são:',
    '<strong>Reservatório (%):</strong> mostra o nível em percentual.',
    '<strong>Valor Atual:</strong> destaca o valor atual e permite configurar cores de alerta. É o componente utilizado neste guia.',
    '<strong>Valor Máximo x Atual:</strong> compara o valor atual com um valor máximo.',
    '<strong>Poço:</strong> mostra nível, bomba e sensor.',
    '<strong>Gráfico de Linhas</strong> e <strong>Gráfico de Barras:</strong> exibem o histórico dos dados.',
    '<strong>Status:</strong> indica se está ligado ou desligado.',
    '<strong>Volume Diário:</strong> mostra o valor acumulado no dia.',
    '<strong>Valor Atual v2:</strong> semelhante ao Valor Atual, com faixas mínimas e máximas.',
    '<strong>Comando:</strong> permite disparar um comando do monitorado.',
    '<strong>Reservatório v2:</strong> mostra o nível do reservatório, sua altura e faixas configuradas.',
    '<strong>Lista de Alertas:</strong> mostra os últimos alertas.',
    '<strong>Gráfico Gauge:</strong> apresenta o valor em uma escala com ponteiro.',
].join('<br><br>')

const dispatchSupervisorioTour = (action, extra = {}) => {
    document.dispatchEvent(new CustomEvent('hdv-tour-supervisorio-demo', { detail: { action, ...extra } }))
}

const findModalButton = (labelPattern) => Array.from(document.querySelectorAll('.modal.show button'))
    .find((button) => /fechar/i.test(button.textContent || ''))

const closeVisibleModal = () => {
    const closeButton = findModalButton(/fechar/i)
    if (closeButton) {
        closeButton.click()
        return
    }

    document.querySelector('.modal.show .close')?.click()
}

const openOptionsMenu = () => {
    const optionsMenu = document.querySelector('details.hdv-super-popup')
    if (optionsMenu) optionsMenu.open = true
}

const closeOptionsMenu = () => {
    document.querySelectorAll('details.hdv-super-popup').forEach((element) => {
        element.open = false
    })
}

const isElementVisible = (element) => {
    if (!element) return false

    const rect = element.getBoundingClientRect()
    const style = window.getComputedStyle(element)

    return rect.width > 0
        && rect.height > 0
        && style.visibility !== 'hidden'
        && style.display !== 'none'
}

const waitForVisibleElement = async (selector, timeout = 2500) => {
    const start = Date.now()

    while (Date.now() - start < timeout) {
        const element = document.querySelector(selector)
        if (isElementVisible(element)) return element
        await delay(50)
    }

    return document.querySelector(selector)
}

const isWidgetModalOpen = () => Boolean(document.querySelector(WIDGET_MODAL_OPEN))

const isEditModalOpen = () => Boolean(document.querySelector(EDIT_MODAL_CONTENT))

const setSupervisorioTab = async (tabName) => {
    dispatchSupervisorioTour('set-tab', { tab: tabName === 'planta' ? 1 : 0 })
    await delay(320)
}

let supervisorioTourAdvancing = false

const beginSupervisorioAdvance = () => {
    if (supervisorioTourAdvancing) return false
    supervisorioTourAdvancing = true
    return true
}

const endSupervisorioAdvance = () => {
    setTimeout(() => {
        supervisorioTourAdvancing = false
    }, 500)
}

const unbindClickToAdvance = (element) => {
    if (!element?._hdvTourAdvance) return

    element.removeEventListener('click', element._hdvTourAdvance)
    element.removeEventListener('click', element._hdvTourAdvance, true)
    delete element._hdvTourAdvance
}

const goToNextWhenVisible = async (tourManager, selector, prepare) => {
    if (!beginSupervisorioAdvance()) return

    try {
        if (typeof prepare === 'function') {
            await prepare()
        }

        if (selector) {
            await waitForVisibleElement(selector, 2500)
        } else {
            await delay(80)
        }

        if (tourManager.isActive()) tourManager.moveNext()
        tourManager.driverObj?.refresh?.()
    } finally {
        endSupervisorioAdvance()
    }
}

const openCreateModal = async (tourManager) => {
    tourManager.supervisorioModalLock = true
    closeOptionsMenu()

    if (document.querySelector('.modal.show [data-tour="supervisorio-criar-descricao"]')) return

    const novoButton = document.querySelector('[data-tour="supervisorio-novo"]')
    unbindClickToAdvance(novoButton)
    novoButton?.click()

    try {
        await tourManager.waitForElement('[data-tour="supervisorio-criar-descricao"]', 4000)
    } catch (error) {}

    await delay(200)
}

const closeCreateModal = (tourManager) => {
    if (document.querySelector('.modal.show [data-tour="supervisorio-criar-descricao"]')) {
        closeVisibleModal()
    }

    if (tourManager) tourManager.supervisorioModalLock = false
}

const openWidgetModal = async (tourManager) => {
    tourManager.supervisorioModalLock = true

    if (isWidgetModalOpen()) return

    dispatchSupervisorioTour('apply-shell')
    await delay(250)
    openOptionsMenu()
    await delay(200)

    if (isWidgetModalOpen()) {
        closeOptionsMenu()
        return
    }

    const novoComponenteButton = document.querySelector('[data-tour="supervisorio-novo-componente"]')
    if (novoComponenteButton && !novoComponenteButton.disabled) {
        unbindClickToAdvance(novoComponenteButton)
        novoComponenteButton.click()
    }

    try {
        await tourManager.waitForElement(WIDGET_MODAL_OPEN, 4000)
    } catch (error) {}

    closeOptionsMenu()
    dispatchSupervisorioTour('ensure-select-options')
    await delay(250)
}

const closeWidgetModal = (tourManager) => {
    if (isWidgetModalOpen()) {
        closeVisibleModal()
    }

    if (tourManager) tourManager.supervisorioModalLock = false
}

const leaveWidgetModal = async (tourManager) => {
    closeWidgetModal(tourManager)
    await delay(220)

    const hasWidget = Boolean(document.querySelector('[data-tour="supervisorio-widget"]'))

    if (!hasWidget) {
        dispatchSupervisorioTour('apply')
        try {
            await tourManager.waitForElement('[data-tour="supervisorio-widget"]', 2500)
        } catch (error) {}
        await waitForVisibleElement('[data-tour="supervisorio-widget"]', 1500)
        await delay(200)
    }
}

const openEditModal = async (tourManager) => {
    tourManager.supervisorioModalLock = true
    unbindClickToAdvance(document.querySelector('[data-tour="supervisorio-widget-menu"]'))

    if (!isEditModalOpen()) {
        dispatchSupervisorioTour('open-edit')
    }

    try {
        await tourManager.waitForElement(EDIT_MODAL_CONTENT, 4000)
    } catch (error) {}

    await waitForVisibleElement(EDIT_MODAL_CONTENT, 2500)
    await delay(200)
}

const closeEditModal = (tourManager) => {
    if (document.querySelector('.modal.show [data-tour="supervisorio-modal-edit"], .modal.show [data-tour="supervisorio-edit-descricao"]')) {
        closeVisibleModal()
    }

    if (tourManager) tourManager.supervisorioModalLock = false
}

export const restoreSupervisorioTourLayout = () => {
    closeOptionsMenu()
    dispatchSupervisorioTour('close-selector')
    dispatchSupervisorioTour('set-tab', { tab: 0 })

    const closeButton = Array.from(document.querySelectorAll('.modal.show button'))
        .find((button) => /fechar/i.test(button.textContent || ''))

    if (closeButton) {
        closeButton.click()
    } else {
        document.querySelector('.modal.show .close')?.click()
    }

    dispatchSupervisorioTour('restore')
    restoreSupervisorioTourDemo()
}

const bindClickToAdvance = (element, tourManager, beforeAdvance) => {
    if (!element || element._hdvTourAdvance) return

    const onClick = () => {
        unbindClickToAdvance(element)

        const advance = async () => {
            if (!beginSupervisorioAdvance()) return

            try {
                if (typeof beforeAdvance === 'function') {
                    await beforeAdvance()
                } else {
                    await delay(220)
                }

                if (tourManager.isActive()) tourManager.moveNext()
            } finally {
                endSupervisorioAdvance()
            }
        }

        advance()
    }

    element.addEventListener('click', onClick)
    element._hdvTourAdvance = onClick
}

export const buildSupervisorioTourSteps = (tourManager) => {
    const formSteps = [
        {
            element: '[data-tour="supervisorio-abas"]',
            tab: 'widgets',
            popover: {
                title: 'Abas',
                description: 'A tela possui duas abas.<br><br><strong>Widgets</strong> é o painel principal. É aqui que você adiciona e organiza os componentes.<br><br><strong>Planta Baixa</strong> mostra os monitorados sobre um mapa ou uma foto do local.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-seletor"]',
            tab: 'widgets',
            popover: {
                title: 'Seus supervisórios',
                description: 'Use esta lista para escolher qual painel deseja visualizar.<br><br>Se ainda não houver nenhum painel, a lista ficará vazia até você criar o primeiro.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-novo"]',
            tab: 'widgets',
            popover: {
                title: 'Novo',
                description: '<strong>Novo</strong> abre o cadastro de outro supervisório. Cada um é um painel separado, com os próprios componentes.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-criar-descricao"]', () => openCreateModal(tourManager))
                },
            },
            onHighlighted: (element) => bindClickToAdvance(element, tourManager, async () => {
                await openCreateModal(tourManager)
            }),
            onDeselected: (element) => unbindClickToAdvance(element),
        },
        {
            element: '[data-tour="supervisorio-criar-descricao"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openCreateModal(activeTourManager),
            popover: {
                title: 'Nome do painel',
                description: 'Escreva um nome fácil de reconhecer. É assim que este supervisório aparece na lista.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => {
                    closeCreateModal(tourManager)
                    setTimeout(() => tourManager.movePrevious(), 280)
                },
            },
        },
        {
            element: '[data-tour="supervisorio-criar-tipo"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openCreateModal(activeTourManager),
            popover: {
                title: 'Tipo',
                description: '<strong>Empresa</strong> deixa o painel disponível para a sua operação.<br><br><strong>Cliente</strong> vincula o painel a um cliente. Nesse caso, o campo de cliente aparece em seguida.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-criar-acoes"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openCreateModal(activeTourManager),
            popover: {
                title: 'Criar o painel',
                description: '<strong>Criar</strong> grava o supervisório.<br><br>Se estiver só acompanhando o guia, o exemplo daqui para frente não será salvo.',
                side: 'top',
                align: 'end',
                onNextClick: () => {
                    tourManager.setHighlightVisible?.(false)
                    closeCreateModal(tourManager)
                    dispatchSupervisorioTour('apply-shell')
                    setTimeout(() => {
                        tourManager.moveNext()
                        tourManager.setHighlightVisible?.(true)
                        tourManager.driverObj?.refresh?.()
                    }, 280)
                },
            },
            onHighlighted: (element) => {
                const criarButton = Array.from(element.querySelectorAll('button')).find((button) => /criar/i.test(button.textContent || ''))
                bindClickToAdvance(criarButton, tourManager, async () => {
                    dispatchSupervisorioTour('apply-shell')
                    await delay(280)
                })
            },
            onDeselected: (element) => {
                const criarButton = Array.from(element?.querySelectorAll?.('button') || []).find((button) => /criar/i.test(button.textContent || ''))
                unbindClickToAdvance(criarButton)
            },
        },
        {
            element: '[data-tour="supervisorio-opcoes"]',
            tab: 'widgets',
            popover: {
                title: 'Opções',
                description: 'O menu <strong>Opções</strong> reúne as ações do painel: criar componente, apresentar, compartilhar e ativar a edição.',
                side: 'left',
                align: 'start',
                onNextClick: () => {
                    tourManager.supervisorioModalLock = true
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-novo-componente"]', async () => {
                        openOptionsMenu()
                    })
                },
            },
        },
        {
            element: '[data-tour="supervisorio-novo-componente"]',
            tab: 'widgets',
            openOptions: true,
            popover: {
                title: 'Novo Componente',
                description: 'É por aqui que você adiciona um widget ao painel. Cada widget mostra um dado de um jeito diferente.',
                side: 'left',
                align: 'start',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, WIDGET_MODAL_OPEN, () => openWidgetModal(tourManager))
                },
            },
            onHighlighted: (element) => bindClickToAdvance(element, tourManager, async () => {
                await openWidgetModal(tourManager)
            }),
            onDeselected: (element) => unbindClickToAdvance(element),
        },
        {
            element: '[data-tour="supervisorio-widget-descricao"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openWidgetModal(activeTourManager),
            popover: {
                title: 'Nome do widget',
                description: 'Este texto aparece no topo do componente. Use um nome que identifique o que está sendo medido, como nível do reservatório ou temperatura.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => {
                    closeWidgetModal(tourManager)
                    openOptionsMenu()
                    setTimeout(() => tourManager.movePrevious(), 280)
                },
            },
        },
        {
            element: '[data-tour="supervisorio-widget-monitorado"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openWidgetModal(activeTourManager),
            popover: {
                title: 'Monitorado',
                description: 'O widget lê dados de um <strong>monitorado</strong> já cadastrado. Sem monitorado, a lista fica vazia.<br><br>As opções são as da sua conta. Se ainda não houver cadastro, o guia pode mostrar um exemplo.',
                side: 'right',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-parametro"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openWidgetModal(activeTourManager),
            popover: {
                title: 'Parâmetro',
                description: 'Depois do monitorado, escolha o <strong>parâmetro</strong> que o widget vai exibir. A lista só preenche quando aquele monitorado tem parâmetros vinculados.<br><br>Este é o dado medido, como temperatura, nível ou vazão.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-tipo"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openWidgetModal(activeTourManager),
            popover: {
                title: 'Tipo do componente',
                popoverClass: 'hdv-tour-popover hdv-tour-popover-supervisorio-tipo',
                description: TIPO_COMPONENTE_DESCRIPTION,
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-config"]',
            tab: 'widgets',
            ensureItem: async (activeTourManager) => {
                await openWidgetModal(activeTourManager)
                dispatchSupervisorioTour('select-valor-atual')
                await delay(250)
            },
            popover: {
                title: 'Valor Atual',
                description: 'Ao escolher <strong>Valor Atual</strong>, aparece o bloco de configurações. O componente mostra o último valor recebido, a unidade e muda de cor conforme os limites que você definir.',
                side: 'top',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-valor-normal"]',
            tab: 'widgets',
            ensureItem: async (activeTourManager) => {
                await openWidgetModal(activeTourManager)
                dispatchSupervisorioTour('select-valor-atual')
                await delay(250)
            },
            popover: {
                title: 'Valor Normal',
                description: 'Até este número, o widget fica <strong>verde</strong>. Use o limite em que a operação está ok.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-valor-alerta"]',
            tab: 'widgets',
            ensureItem: async (activeTourManager) => {
                await openWidgetModal(activeTourManager)
                dispatchSupervisorioTour('select-valor-atual')
                await delay(250)
            },
            popover: {
                title: 'Valor Alerta',
                description: 'Entre o normal e este valor, o widget fica <strong>amarelo</strong>. Indica que o dado saiu da faixa ideal e merece atenção.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-valor-perigo"]',
            tab: 'widgets',
            ensureItem: async (activeTourManager) => {
                await openWidgetModal(activeTourManager)
                dispatchSupervisorioTour('select-valor-atual')
                await delay(250)
            },
            popover: {
                title: 'Valor Perigoso',
                description: 'A partir deste número, o widget fica <strong>vermelho</strong>. Use o limite em que a situação é crítica.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-icone"]',
            tab: 'widgets',
            ensureItem: async (activeTourManager) => {
                await openWidgetModal(activeTourManager)
                dispatchSupervisorioTour('select-valor-atual')
                await delay(250)
            },
            popover: {
                title: 'Ícone',
                description: 'Campo opcional. Escolha um ícone para reconhecer o widget de relance.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-minutos-alerta-semcomunicacao"]',
            tab: 'widgets',
            ensureItem: async (activeTourManager) => {
                await openWidgetModal(activeTourManager)
                dispatchSupervisorioTour('select-valor-atual')
                await delay(250)
            },
            popover: {
                title: 'Alerta de comunicação',
                description: 'Campo obrigatório. Informe em minutos quanto tempo sem atualização deixa o widget como <strong>atrasado</strong>. Assim você percebe quando o equipamento parou de comunicar.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-widget-adicionar"]',
            tab: 'widgets',
            ensureItem: async (activeTourManager) => {
                await openWidgetModal(activeTourManager)
                dispatchSupervisorioTour('select-valor-atual')
                await delay(250)
            },
            popover: {
                title: 'Adicionar',
                description: '<strong>Adicionar</strong> inclui o componente no painel.<br><br>Se o painel ainda estiver vazio, o guia exibirá um <strong>Valor Atual</strong> de exemplo apenas para demonstrar o resultado. Esse exemplo não será salvo.',
                side: 'top',
                align: 'end',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-widget"]', () => leaveWidgetModal(tourManager))
                },
            },
            onHighlighted: (element) => bindClickToAdvance(element, tourManager, async () => {
                await leaveWidgetModal(tourManager)
            }),
            onDeselected: (element) => unbindClickToAdvance(element),
        },
        {
            element: '[data-tour="supervisorio-widget"]',
            tab: 'widgets',
            needsCanvas: true,
            popover: {
                title: 'O widget no painel',
                description: 'O <strong>Valor Atual</strong> mostra o número, a unidade e a cor conforme os limites. O circulo verde no canto indica se a comunicação está em dia, se estiver atrasado ou sem comunicação, o circulo fica vermelho.<br><br>Este é um exemplo apenas para o guia, e não será salvo.',
                side: 'right',
                align: 'start',
                onNextClick: () => {
                    tourManager.supervisorioModalLock = true
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-editar"]', async () => {
                        dispatchSupervisorioTour('apply-shell')
                        openOptionsMenu()
                    })
                },
                onPrevClick: () => {
                    openWidgetModal(tourManager).then(() => tourManager.movePrevious())
                },
            },
        },
        {
            element: '[data-tour="supervisorio-editar"]',
            tab: 'widgets',
            openOptions: true,
            needsCanvas: true,
            popover: {
                title: 'Editar',
                description: '<strong>Editar</strong> libera mover, redimensionar e abrir o menu de cada componente.',
                side: 'left',
                align: 'start',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-widget"]', async () => {
                        dispatchSupervisorioTour('set-edit-enabled', { enabled: true })
                        closeOptionsMenu()
                        await delay(220)
                    })
                },
            },
            onHighlighted: (element) => bindClickToAdvance(element, tourManager, async () => {
                dispatchSupervisorioTour('set-edit-enabled', { enabled: true })
                closeOptionsMenu()
                await delay(220)
            }),
            onDeselected: (element) => unbindClickToAdvance(element),
        },
        {
            element: '[data-tour="supervisorio-widget"]',
            tab: 'widgets',
            needsCanvas: true,
            needsEdit: true,
            popover: {
                title: 'Organizar o widget',
                description: 'Com a edição ativa, arraste pelo ícone de setas para reposicionar o widget.<br><br>Puxe os cantos ou as bordas para aumentar ou diminuir. O tamanho mínimo depende do tipo do componente.',
                side: 'right',
                align: 'start',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-widget-menu"]', async () => {
                        dispatchSupervisorioTour('set-edit-enabled', { enabled: true })
                        await delay(220)
                    })
                },
            },
        },
        {
            element: '[data-tour="supervisorio-widget-menu"]',
            tab: 'widgets',
            needsCanvas: true,
            needsEdit: true,
            disableActiveInteraction: true,
            popover: {
                title: 'Menu do widget',
                description: 'Os três pontinhos abrem a edição daquele componente: nome, parâmetros e exclusão.',
                side: 'right',
                align: 'start',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, EDIT_MODAL_CONTENT, () => openEditModal(tourManager))
                },
            },
        },
        {
            element: EDIT_MODAL_CONTENT,
            tab: 'widgets',
            ensureItem: (activeTourManager) => openEditModal(activeTourManager),
            popover: {
                title: 'Editar componente',
                description: 'Este formulário altera o widget que já está no painel. Aqui você muda o nome, os parâmetros e, se precisar, remove o componente.<br><br>As mudanças valem só para aquele widget. O supervisório continua existindo.',
                side: 'left',
                align: 'start',
                onPrevClick: () => {
                    closeEditModal(tourManager)
                    setTimeout(() => tourManager.movePrevious(), 320)
                },
            },
        },
        {
            element: '[data-tour="supervisorio-edit-descricao"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openEditModal(activeTourManager),
            popover: {
                title: 'Nome e parâmetros',
                description: 'Altere o nome e as mesmas configurações definidas na criação. <strong>Salvar</strong> grava as mudanças no painel.',
                side: 'left',
                align: 'start',
            },
        },
        {
            element: '[data-tour="supervisorio-edit-excluir"]',
            tab: 'widgets',
            ensureItem: (activeTourManager) => openEditModal(activeTourManager),
            popover: {
                title: 'Excluir componente',
                description: '<strong>Excluir Componente</strong> remove só aquele widget. O supervisório continua na lista.<br><br>No guia, o exemplo não será excluído.',
                side: 'top',
                align: 'end',
                onNextClick: () => {
                    tourManager.setHighlightVisible?.(false)
                    closeEditModal(tourManager)
                    setTimeout(() => {
                        tourManager.moveNext()
                        tourManager.setHighlightVisible?.(true)
                        tourManager.driverObj?.refresh?.()
                    }, 280)
                },
            },
        },
        {
            element: '[data-tour="supervisorio-salvar"]',
            tab: 'widgets',
            needsCanvas: true,
            popover: {
                title: 'Salvar',
                description: 'Depois de mover, redimensionar ou alterar widgets, use <strong>Salvar</strong> para gravar o layout.<br><br>Se o guia estiver mostrando um exemplo, este botão permanece bloqueado para não gravar dados fictícios.',
                side: 'bottom',
                align: 'end',
                onNextClick: () => {
                    tourManager.supervisorioModalLock = true
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-apresentacao"]', async () => {
                        openOptionsMenu()
                    })
                },
            },
        },
        {
            element: '[data-tour="supervisorio-apresentacao"]',
            tab: 'widgets',
            openOptions: true,
            disableActiveInteraction: true,
            popover: {
                title: 'Apresentação',
                description: 'A <strong>Apresentação</strong> troca automaticamente entre os supervisórios no intervalo que você escolher. Serve para um monitor em parede ou TV.',
                side: 'left',
                align: 'start',
                onNextClick: () => {
                    tourManager.supervisorioModalLock = true
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-links"]', async () => {
                        openOptionsMenu()
                    })
                },
            },
        },
        {
            element: '[data-tour="supervisorio-links"]',
            tab: 'widgets',
            openOptions: true,
            popover: {
                title: 'Gerenciar Links',
                description: '<strong>Gerenciar Links</strong> cria um endereço para outras pessoas verem o painel sem entrar na plataforma, com data de validade. Não altera os widgets.',
                side: 'left',
                align: 'start',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, '[data-tour="supervisorio-planta-acoes"]', async () => {
                        closeOptionsMenu()
                        dispatchSupervisorioTour('apply-shell')
                        await setSupervisorioTab('planta')
                    })
                },
            },
        },
        {
            element: '[data-tour="supervisorio-planta-acoes"]',
            tab: 'planta',
            popover: {
                title: 'Planta Baixa',
                description: 'Nesta aba você posiciona os monitorados sobre um mapa ou uma foto do local.<br><br><strong>Selecionar Imagem</strong> envia a foto. <strong>Habilitar Edição</strong> permite colocar os pontos no desenho. <strong>Salvar</strong> grava o que foi posicionado.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    goToNextWhenVisible(tourManager, null, async () => {
                        closeOptionsMenu()
                        await setSupervisorioTab('widgets')
                    })
                },
                onPrevClick: () => {
                    closeOptionsMenu()
                    setSupervisorioTab('widgets').then(() => tourManager.movePrevious())
                },
            },
        },
        {
            tab: 'widgets',
            popover: {
                title: 'Pronto',
                description: 'Você já viu como criar um painel, adicionar um <strong>Valor Atual</strong>, organizar os widgets e usar a <strong>Planta Baixa</strong>.<br><br>O exemplo do guia, se ainda estiver na tela, não é salvo ao concluir.',
                side: 'over',
                align: 'center',
                onPrevClick: () => {
                    setSupervisorioTab('planta').then(() => tourManager.movePrevious())
                },
            },
        },
    ]

    return formSteps.map((step) => ({
        ...step,
        ensureReady: async (activeTourManager) => {
            dispatchSupervisorioTour('snapshot')
            await setSupervisorioTab(step.tab)

            const keepOptionsOpen = Boolean(step.openOptions)
            const keepWidgetModal = isWidgetModalOpen()
            const keepEditModal = isEditModalOpen()

            if (!keepOptionsOpen && !keepWidgetModal && !keepEditModal) {
                closeOptionsMenu()
            }

            if (step.tab === 'planta') {
                dispatchSupervisorioTour('apply-shell')
                await delay(200)
            }

            if (step.openOptions) {
                activeTourManager.supervisorioModalLock = true
                dispatchSupervisorioTour('apply-shell')
                openOptionsMenu()
                await delay(280)
                if (step.element) {
                    await waitForVisibleElement(step.element, 2000)
                }
            }

            if (typeof step.ensureItem === 'function') {
                await step.ensureItem(activeTourManager)
            }

            if (step.needsCanvas && !step.openOptions) {
                if (!keepEditModal) closeOptionsMenu()
                const hasWidget = Boolean(document.querySelector('[data-tour="supervisorio-widget"]'))
                if (!hasWidget) {
                    dispatchSupervisorioTour('apply')
                    try {
                        await activeTourManager.waitForElement('[data-tour="supervisorio-widget"]', 2500)
                    } catch (error) {}
                }
                await waitForVisibleElement('[data-tour="supervisorio-widget"]', 1500)
            }

            if (step.needsEdit) {
                dispatchSupervisorioTour('set-edit-enabled', { enabled: true })
                await delay(220)
                if (step.element) {
                    await waitForVisibleElement(step.element, 2000)
                }
            }

            dispatchSupervisorioTour('close-selector')

            if (step.element) {
                try {
                    await activeTourManager.waitForElement(step.element, 2500)
                } catch (error) {}
                await waitForVisibleElement(step.element, 1500)
            }

            activeTourManager.driverObj?.refresh?.()
        },
        onDeselected: (element, currentStep, options) => {
            if (typeof step.onDeselected === 'function') {
                step.onDeselected(element, currentStep, options)
            }
        },
    }))
}
